export const DEFAULT_FONTS = '"Helvetica", "sans-serif"';
//# sourceMappingURL=fonts.js.map